module.exports = __webpack_public_path__ + "static/media/14UNEP17.251c6aa0.jpg";